import { createAction } from "redux-starter-kit";
import {
  ISSUE_LIST_START_LOAD,
  ISSUE_LIST_END_LOAD,
  ISSUE_LIST_LOAD_FAIL,
  ISSUE_LIST_FILTER_KEYWORD_ENTERED,
  ISSUE_LIST_DEL_START,
  ISSUE_LIST_SHOW_CREATE,
  ISSUE_LIST_HIDE_CREATE,
  ISSUE_LIST_RECOVER_ISSUE,
  ISSUE_LIST_UPDATE_CUR_ISSUE
} from "../actionTypes";

import {
  getIssuesApi,
  delIssueApi,
  getCurIssueOfTitle
} from "../../api/issues";

export const startLoadIssuesAction = createAction(ISSUE_LIST_START_LOAD);
export const endLoadIssuesAction = createAction(ISSUE_LIST_END_LOAD);
export const issuesFailLoadAction = createAction(ISSUE_LIST_LOAD_FAIL);
export const filterKeywordEnteredAction = createAction(
  ISSUE_LIST_FILTER_KEYWORD_ENTERED
);
export const delIssueStartAction = createAction(ISSUE_LIST_DEL_START);
export const showCreateAction = createAction(ISSUE_LIST_SHOW_CREATE);
export const hideCreateAction = createAction(ISSUE_LIST_HIDE_CREATE);
export const recoverIssuesAction = createAction(ISSUE_LIST_RECOVER_ISSUE);
export const updateCurIssue = createAction(ISSUE_LIST_UPDATE_CUR_ISSUE);

export function loadIssueRequestAction(titleID, isPdf) {
  return async dispatch => {
    dispatch(startLoadIssuesAction({ titleID, isPdf }));

    try {
      let issues = await getIssuesApi(titleID, isPdf);

      dispatch(
        endLoadIssuesAction({ titleID, isPdf, issues: issues.reverse() })
      );
    } catch (e) {
      dispatch(issuesFailLoadAction({ titleID, isPdf, errMsg: e.toString() }));
    }
  };
}

export function getCurrentIssueRequestAction(titleID) {
  return async dispatch => {
    try {
      let curIssue = await getCurIssueOfTitle(titleID);

      dispatch(updateCurIssue({ currentIssue: curIssue }));
    } catch (e) {
      dispatch(updateCurIssue({ currentIssue: null }));
    }
  };
}

export function delIssueRequestAction(anIssue, isPdf, allIssues, toast) {
  return async dispatch => {
    const issueID = anIssue.id;

    dispatch(delIssueStartAction({ issueID, isPdf }));

    try {
      await delIssueApi(issueID, isPdf);
    } catch (e) {
      dispatch(recoverIssuesAction({ allIssues, isPdf }));
      toast.error(e.toString());
    }
  };
}
